import { BaseModel } from "../../core/src/model/BaseModel"
import IJackpotData from "../server/data/IJackpotData";

class JackpotsModel extends BaseModel<IJackpotData> {
    /**
     * Keeps a value, indicating whether the player is currently playing for jackpot or not.
     *
     * @type {boolean}
     * @memberof JackpotsModel
     */
    public playForJackpot: boolean = false;
    public jackpotWon: boolean = true;
    public jackpotWonName: string = "";
    public winAmount: number = 0;
    public jpAttendanceClientDesired: boolean = false;
    public jackpotFee: number = 0.01;
    
    /**
     * Keeps a value, indicating whether the jackpots on the servers are enabled or not.
     *
     * @type {boolean}
     * @memberof JackpotsModel
     */
    public jackpotsAvailable: boolean = false;

    /**
     * Gets or sets the jackpot names, currently available on the game server.
     * The order defines how the jackpot banner will display them:
     * For landspace - jackpots are displayed from top to bottom,
     * For portrait - jackpots are displayed from left to right.
     *
     * @type {string[]}
     * @memberof JackpotsModel
     */
    public jackpotNames: string[];
};

export default new JackpotsModel();